import { z } from 'zod';
import { syncBookkeepingSchema, uuidSchema } from './base.js';

export const TAG_NAME_MAX = 80;

/**
 * 客户端标签名入口的统一钳制：trim + 截断到 TAG_NAME_MAX。
 * Why（护栏 A）：客户端校验必须与 shared schema 一致——UI 放行超长名而服务端
 * schema 拒绝时，整条 op 被 reject = 用户编辑静默丢失。所有 addTag/updateTag
 * 入口（含 QuickCapture 现场建、内联改名）统一走本函数。
 * 注意：纯空白输入 clamp 后为 ''（不满足 schema min(1)）——调用方必须自行处理空结果
 * （store.updateTag 丢弃该字段；创建入口 UI 层已拦空名）。
 */
export function clampTagName(name: string): string {
  return name.trim().slice(0, TAG_NAME_MAX);
}

export const tagSchema = syncBookkeepingSchema.extend({
  id: uuidSchema,
  name: z.string().min(1).max(TAG_NAME_MAX),
  color: z
    .string()
    .regex(/^#[0-9a-fA-F]{6}$/)
    .nullable(),
});

export type Tag = z.infer<typeof tagSchema>;

export const tagCreateSchema = tagSchema.pick({ id: true, name: true, color: true });
export const tagPatchSchema = tagSchema.pick({ name: true, color: true }).partial();

export type TagCreate = z.infer<typeof tagCreateSchema>;
export type TagPatch = z.infer<typeof tagPatchSchema>;
